import * as bootstrap from 'bootstrap';
import "@vpsoftware/vprealestate-www/modernizr";
import {initializePlans, initGalleries} from "@vpsoftware/vprealestate-www";
import './style.scss';
import './cookie-consent.scss';
import {planOptions, propertyPlanOptions} from './plan.custom';
import {DefaultPermissions, initCookieConsent} from "./cookie-consent";
import {initPriceHistoryButtons} from "./history-price";
import Cookies from "js-cookie";

declare const vpcCaptchaPublicKey: string;
document.addEventListener('DOMContentLoaded', () => {
  initContactForms();
  initGalleries('.plan-lightbox');
  initGalleries('.estate-slider', 'a.slide-img');
  initCookieConsent(DefaultPermissions);
  
  initPropertyListSorting();
  initPropertyListExpand();
  initSliderNav();
  initAskForOffer();
  initPriceHistoryButtons();
  initLazyLightbox();
  initCmsPopup();
});

function initLazyLightbox() {
    const lazyLightboxObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && entry.target.classList.contains('vp-lightbox')) {
                loadLazyLightbox(entry.target as HTMLAnchorElement);
                lazyLightboxObserver.unobserve(entry.target);
            }
        });
    });
    
    document.querySelectorAll('.plan-lightbox-path-image .lazy-lightbox').forEach(lightbox => {
        lazyLightboxObserver.observe(lightbox);
    });
}

async function loadLazyLightbox(element: HTMLAnchorElement) {
    const propertyId = element.getAttribute('data-property-id');
    const cssClass = element.getAttribute('data-css-class') || 'vp-lightbox';
    const imageCssClass = element.getAttribute('data-image-css-class') || '';
    
    if (!propertyId) {
        console.error('Property ID not found for lazy lightbox');
        return;
    }

    try {
        const response = await fetch('/api/lazy-lightbox', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                propertyId: parseInt(propertyId),
                cssClass: cssClass,
                imageCssClass: imageCssClass
            })
        });
        
        if (response.ok) {
            const html = await response.text();
            element.outerHTML = html;
            initGalleries(`#lightbox-${propertyId}.plan-lightbox-path-image`, 'a');
        } else {
            console.error('Failed to load lazy lightbox, status:', response.status);
            element.remove();
        }
    } catch (error) {
        console.error('Failed to load lazy lightbox:', error);
        element.remove();
    }
}



document.querySelectorAll<HTMLImageElement>('.estate-list-section .plan-lightbox img').forEach(img => {
  if (img.complete && img.naturalWidth == 0) {
    img.closest('.plan-lightbox').remove();
  } else {
    img.addEventListener('error', err => {
      img.closest('.plan-lightbox').remove();
    });
  }
});

function initPropertyListSorting() {
  const sortControls = document.querySelectorAll('.estate-list-section .sort-control');
  sortControls.forEach(control => {
    control.addEventListener('change', change => {
      const target = change.target as HTMLInputElement;
      let val = target.value;
      let list = target.closest<HTMLElement>('.estate-list-section');
      let priceElements = Array.from(list.querySelectorAll('[data-price]')).map((element : HTMLElement) => ({
        element,
        price: Number(element.dataset.price)
      }));

      let container = target.closest('.container');

      priceElements.forEach(p => p.element.remove());
      priceElements.sort((p1, p2) => {
        let diff = p2.price - p1.price;
        if (val === 'low') return -diff;
        return diff;
      });
      priceElements.forEach(p => {
        container.appendChild(p.element);
      });
    });
  });
}
function initPropertyListExpand() {
  document.querySelectorAll('.expand-list').forEach(expand => {
    expand.addEventListener('click', evt => {
      evt.preventDefault();
      let section = (evt.target as HTMLElement).closest('section');
      let prevSection = section.previousElementSibling as HTMLElement;
      let container = prevSection.querySelector('.container.collapsed');
      if (container){
        container.classList.remove('collapsed');
      }
      section.classList.add('d-none');
    });
  });

}

function initSliderNav() {
  const mainModalElement = document.querySelector<HTMLDivElement>('#homeCarousel');
  if (!mainModalElement) return;
  let buttons = mainModalElement.querySelectorAll<HTMLButtonElement>('.home-carousel-nav button.slide-button');
  (mainModalElement as Element).addEventListener("slide.bs.carousel", (evt: bootstrap.Carousel.Event) => {
    buttons.forEach(b => {
      const shouldBeActive = b.dataset.bsSlideTo === '' + evt.to;
      b.classList.toggle('active', shouldBeActive);
    })
  })
}

export function initializeDefaultPlan() {
  initializePlans('picture.plan-image.clickable-plan', planOptions);
}

export function initializePropertyPlan() {
  initializePlans('picture.plan-image.clickable-plan:not(.floor-plan)', propertyPlanOptions);
  initializePlans('picture.plan-image.clickable-plan.floor-plan', planOptions);
}

function initAskForOffer() {
  let links = document.querySelectorAll<HTMLAnchorElement>('a[data-offer-form]');
  links.forEach(link => {
    link.addEventListener('click', evt => {
      evt.preventDefault();
      let propertyId = Number(link.dataset.offerForm);
      if (!isNaN(propertyId)) {
        let address = `${link.dataset.offerCity},  ${link.dataset.offerStreet} ${link.dataset.offerBuildingNumber} m. ${link.dataset.offerPropertyNumber}`;
        openAskOfferPopup(propertyId, address);
      }
    });
  })
}

function openAskOfferPopup(propertyId: number, propertyAddress: string) {
  let modalElement = document.getElementById('askOfferModal');
  if (!modalElement) return;
  let address = modalElement.querySelector<HTMLElement>('.property-address');
  if (address) {
    address.innerText = propertyAddress;
  }
  let form = (<HTMLFormElement>document.getElementById('contactFormPopup'));
  if (form) {
    form.reset();
    let propId = form.querySelector<HTMLInputElement>('input[name="property-id"]');
    propId.value = ""+propertyId;
  } else {
    return;
  }
  let modal = bootstrap.Modal.getOrCreateInstance(modalElement);
  modal.show();
}


function initContactForms() {
  let forms = document.querySelectorAll<HTMLFormElement>('form.contact-form');
  for (let i = 0, l = forms.length; i < l; i++) {
    initContactForm(forms.item(i))
  }
}

function closeAskOfferPopup() {
  let modalElement = document.getElementById('askOfferModal');
  if (!modalElement) return;
  let modal = bootstrap.Modal.getInstance(modalElement);
  if (!modal) return;
  modal.hide();
}

function initContactForm(form: HTMLFormElement) {
  // setup requirement for either email or phone number
  const inputs = Array.from(
    form.querySelectorAll<HTMLInputElement>("[name='email'], [name='phone-number']")
  );

  const inputListener = (e: InputEvent) => {
    inputs
      .filter(i => i !== e.target)
      .forEach(i => (i.required = !(e.target as HTMLInputElement).value.length));
  };
  inputs.forEach(i => i.addEventListener('input', inputListener));


  const contactModalElement = document.getElementById('contactModal');
  const modal = bootstrap.Modal.getOrCreateInstance(contactModalElement);

  let submitButton = form.querySelector('button[type="submit"]');
  form.addEventListener('submit', function (event) {
    
    const overlay = document.getElementById('spinnerOverlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    
    event.preventDefault();
    submitButton.setAttribute('disabled', 'disabled');
    const xhr = new XMLHttpRequest();
    let controls = ['name', 'email', 'phone-number', 'subject', 'message', 'property-id'].map(x => form.querySelector<HTMLInputElement>(`[name='${x}']`))
      .filter(x => !!x);
    let request = '';

    function resetForm() {
      for (let control of controls) {
        control.removeAttribute('disabled');
      }
      submitButton.removeAttribute('disabled');
    }

    for (let control of controls) {
      request += control.name + "=" + encodeURIComponent(control.value) + '&';
      control.setAttribute('disabled', 'disabled');
    }
    let tokenInput = form.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]');
    request += '__RequestVerificationToken=' + tokenInput.value;
    xhr.addEventListener('loadend', function () {

      const overlay = document.getElementById('spinnerOverlay');
      if (overlay) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      resetForm();
      let status = xhr.status;
      let body = contactModalElement.querySelector<HTMLDivElement>('.modal-body');
      if (status !== 200 && status !== 204) {
        body.innerText = 'Nie udało się wysłać prośby o kontakt';
      } else {
        body.innerText = 'Prośba o kontakt została wysłana';
        for (let control of controls) {
          control.value = '';
        }
        closeAskOfferPopup();
      }
      modal.show();
    });
    if (typeof vpcCaptchaPublicKey !== 'undefined') {
      grecaptcha.ready(function () {
        grecaptcha.execute(vpcCaptchaPublicKey, {action: 'submit'}).then(
          function (token) {
            request += '&token=' + token;
            xhr.open('POST', '/Kontakt-Wyslij', true);
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhr.send(request);
          }, err => {
            console.error(err);
            alert('Błąd wysyłki prośby o kontakt');
          });
      });
    } else {
      xhr.open('POST', '/Kontakt-Wyslij', true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.send(request);
    }
  });
}

function initCmsPopup() {
    const modalElement = document.getElementById('cmsModal');
    if (!modalElement)
        return;
    
    const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
    if (!modal)
        return;

    modal.show();

    const popupId = modalElement.dataset.popupId;
    if (!popupId)
        return;

    const cookieName = 'popupsShown';
    const previousValue = Cookies.get(cookieName);
    Cookies.set('popupsShown', `${previousValue?.length ? previousValue + ';' : ''}${popupId}`, {expires: 365, sameSite: 'none', secure: true});
}